@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-299_603_249)
public val Res.string.auth_reset_password_desc: StringResource by lazy {
      StringResource("string:auth_reset_password_desc", "auth_reset_password_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28503, 132),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39471, 228),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23558, 136),
      ))
    }

@delegate:ResourceContentHash(2_139_870_565)
public val Res.string.auth_reset_password_title: StringResource by lazy {
      StringResource("string:auth_reset_password_title", "auth_reset_password_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28636, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39700, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23695, 53),
      ))
    }

@delegate:ResourceContentHash(-894_568_582)
public val Res.string.auth_reset_sent: StringResource by lazy {
      StringResource("string:auth_reset_sent", "auth_reset_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28686, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39774, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23749, 75),
      ))
    }

@delegate:ResourceContentHash(223_164_757)
public val Res.string.auth_return_to_login: StringResource by lazy {
      StringResource("string:auth_return_to_login", "auth_return_to_login", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28798, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39926, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23825, 48),
      ))
    }

@delegate:ResourceContentHash(-1_109_945_199)
public val Res.string.auth_sign_in: StringResource by lazy {
      StringResource("string:auth_sign_in", "auth_sign_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28919, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 40067, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23930, 32),
      ))
    }

@delegate:ResourceContentHash(783_463_212)
public val Res.string.auth_sign_in_with_apple: StringResource by lazy {
      StringResource("string:auth_sign_in_with_apple", "auth_sign_in_with_apple", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28855, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 40007, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23874, 55),
      ))
    }

@delegate:ResourceContentHash(422_397_668)
public val Res.string.auth_sign_up: StringResource by lazy {
      StringResource("string:auth_sign_up", "auth_sign_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28956, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 40104, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23963, 32),
      ))
    }

@delegate:ResourceContentHash(674_868_833)
public val Res.string.auth_switch_to_login: StringResource by lazy {
      StringResource("string:auth_switch_to_login", "auth_switch_to_login", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29001, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 40165, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23996, 72),
      ))
    }

@delegate:ResourceContentHash(166_805_625)
public val Res.string.auth_switch_to_register: StringResource by lazy {
      StringResource("string:auth_switch_to_register", "auth_switch_to_register", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29070, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 40274, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24069, 51),
      ))
    }

@delegate:ResourceContentHash(-196_683_236)
public val Res.string.auth_toggle_password_visibility: StringResource by lazy {
      StringResource("string:auth_toggle_password_visibility", "auth_toggle_password_visibility", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29146, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 40370, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24121, 75),
      ))
    }

@delegate:ResourceContentHash(1_289_435_707)
public val Res.string.auth_verification_sent: StringResource by lazy {
      StringResource("string:auth_verification_sent", "auth_verification_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29218, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 40486, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24197, 62),
      ))
    }

@delegate:ResourceContentHash(900_317_861)
public val Res.string.auth_verify_email: StringResource by lazy {
      StringResource("string:auth_verify_email", "auth_verify_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29516, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 41084, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24507, 77),
      ))
    }

@delegate:ResourceContentHash(1_194_455_147)
public val Res.string.auth_verify_email_desc: StringResource by lazy {
      StringResource("string:auth_verify_email_desc", "auth_verify_email_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29289, 162),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 40601, 366),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24260, 190),
      ))
    }

@delegate:ResourceContentHash(-132_334_337)
public val Res.string.auth_verify_email_title: StringResource by lazy {
      StringResource("string:auth_verify_email_title", "auth_verify_email_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29452, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 40968, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24451, 55),
      ))
    }

@delegate:ResourceContentHash(802_457_238)
public val Res.string.auto_assign: StringResource by lazy {
      StringResource("string:auto_assign", "auto_assign", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36633, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50997, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31196, 35),
      ))
    }

@delegate:ResourceContentHash(-1_814_320_234)
public val Res.string.auto_assign_ai_badge: StringResource by lazy {
      StringResource("string:auto_assign_ai_badge", "auto_assign_ai_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29602, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 41222, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24585, 32),
      ))
    }

@delegate:ResourceContentHash(721_078_895)
public val Res.string.auto_assign_ai_dropped: StringResource by lazy {
      StringResource("string:auto_assign_ai_dropped", "auto_assign_ai_dropped", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 30101, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 41857, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25092, 66),
      ))
    }

@delegate:ResourceContentHash(-1_965_058_567)
public val Res.string.auto_assign_ai_dropped_because: StringResource by lazy {
      StringResource("string:auto_assign_ai_dropped_because", "auto_assign_ai_dropped_because", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29635, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 41255, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24618, 66),
      ))
    }

@delegate:ResourceContentHash(-958_572_437)
public val Res.string.auto_assign_ai_dropped_duplicate: StringResource by lazy {
      StringResource("string:auto_assign_ai_dropped_duplicate", "auto_assign_ai_dropped_duplicate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29702, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 41334, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24685, 88),
      ))
    }

@delegate:ResourceContentHash(-654_734_065)
public val Res.string.auto_assign_ai_dropped_shift: StringResource by lazy {
      StringResource("string:auto_assign_ai_dropped_shift", "auto_assign_ai_dropped_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29869, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 41557, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24848, 48),
      ))
    }

@delegate:ResourceContentHash(-964_331_677)
public val Res.string.auto_assign_ai_dropped_shift_not_open: StringResource by lazy {
      StringResource("string:auto_assign_ai_dropped_shift_not_open", "auto_assign_ai_dropped_shift_not_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29795, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 41467, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24774, 73),
      ))
    }

@delegate:ResourceContentHash(-285_571_224)
public val Res.string.auto_assign_ai_dropped_unknown_alias: StringResource by lazy {
      StringResource("string:auto_assign_ai_dropped_unknown_alias", "auto_assign_ai_dropped_unknown_alias", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 29914, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 41610, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24897, 108),
      ))
    }

@delegate:ResourceContentHash(1_285_617_550)
public val Res.string.auto_assign_ai_dropped_unknown_person: StringResource by lazy {
      StringResource("string:auto_assign_ai_dropped_unknown_person", "auto_assign_ai_dropped_unknown_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 30019, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 41747, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25006, 85),
      ))
    }

@delegate:ResourceContentHash(806_778_901)
public val Res.string.auto_assign_ai_fallback_disabled: StringResource by lazy {
      StringResource("string:auto_assign_ai_fallback_disabled", "auto_assign_ai_fallback_disabled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 30172, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 41956, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25159, 132),
      ))
    }

@delegate:ResourceContentHash(1_515_353_921)
public val Res.string.auto_assign_ai_fallback_failed: StringResource by lazy {
      StringResource("string:auto_assign_ai_fallback_failed", "auto_assign_ai_fallback_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 30293, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 42121, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25292, 106),
      ))
    }

@delegate:ResourceContentHash(-1_216_247_870)
public val Res.string.auto_assign_ai_fallback_not_allowed: StringResource by lazy {
      StringResource("string:auto_assign_ai_fallback_not_allowed", "auto_assign_ai_fallback_not_allowed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 30396, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 42248, 227),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25399, 139),
      ))
    }

@delegate:ResourceContentHash(138_627_515)
public val Res.string.auto_assign_ai_fallback_plan: StringResource by lazy {
      StringResource("string:auto_assign_ai_fallback_plan", "auto_assign_ai_fallback_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 30556, 124),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 42476, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25539, 120),
      ))
    }

@delegate:ResourceContentHash(225_140_533)
public val Res.string.auto_assign_ai_fallback_quota: StringResource by lazy {
      StringResource("string:auto_assign_ai_fallback_quota", "auto_assign_ai_fallback_quota", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 30681, 133),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 42669, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25660, 125),
      ))
    }

@delegate:ResourceContentHash(1_024_516_178)
public val Res.string.auto_assign_ai_fallback_too_large: StringResource by lazy {
      StringResource("string:auto_assign_ai_fallback_too_large", "auto_assign_ai_fallback_too_large", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 30815, 133),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 42867, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25786, 137),
      ))
    }

@delegate:ResourceContentHash(-780_468_435)
public val Res.string.auto_assign_ai_planning: StringResource by lazy {
      StringResource("string:auto_assign_ai_planning", "auto_assign_ai_planning", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 30949, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 43057, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25924, 115),
      ))
    }

@delegate:ResourceContentHash(425_925_974)
public val Res.string.auto_assign_ai_privacy: StringResource by lazy {
      StringResource("string:auto_assign_ai_privacy", "auto_assign_ai_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31057, 158),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 43233, 238),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26040, 150),
      ))
    }

@delegate:ResourceContentHash(1_677_991_798)
public val Res.string.auto_assign_ai_suggest: StringResource by lazy {
      StringResource("string:auto_assign_ai_suggest", "auto_assign_ai_suggest", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31216, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 43472, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26191, 50),
      ))
    }

@delegate:ResourceContentHash(-247_177_635)
public val Res.string.auto_assign_ai_used: StringResource by lazy {
      StringResource("string:auto_assign_ai_used", "auto_assign_ai_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31267, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 43547, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26242, 115),
      ))
    }

@delegate:ResourceContentHash(-1_471_514_913)
public val Res.string.auto_assign_applied: StringResource by lazy {
      StringResource("string:auto_assign_applied", "auto_assign_applied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31391, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 43719, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26358, 55),
      ))
    }

@delegate:ResourceContentHash(1_321_690_736)
public val Res.string.auto_assign_apply: StringResource by lazy {
      StringResource("string:auto_assign_apply", "auto_assign_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31455, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 43795, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26414, 45),
      ))
    }

@delegate:ResourceContentHash(1_223_834_942)
public val Res.string.auto_assign_gap_absent: StringResource by lazy {
      StringResource("string:auto_assign_gap_absent", "auto_assign_gap_absent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31505, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 43857, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26460, 54),
      ))
    }

@delegate:ResourceContentHash(-1_604_481_372)
public val Res.string.auto_assign_gap_already_working_that_day: StringResource by lazy {
      StringResource("string:auto_assign_gap_already_working_that_day", "auto_assign_gap_already_working_that_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31572, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 43940, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26515, 80),
      ))
    }

@delegate:ResourceContentHash(1_826_906_034)
public val Res.string.auto_assign_gap_busy_elsewhere: StringResource by lazy {
      StringResource("string:auto_assign_gap_busy_elsewhere", "auto_assign_gap_busy_elsewhere", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31653, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 44045, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26596, 78),
      ))
    }

@delegate:ResourceContentHash(-237_175_110)
public val Res.string.auto_assign_gap_insufficient_rest: StringResource by lazy {
      StringResource("string:auto_assign_gap_insufficient_rest", "auto_assign_gap_insufficient_rest", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31724, 93),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 44148, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26675, 81),
      ))
    }

@delegate:ResourceContentHash(1_847_097_439)
public val Res.string.auto_assign_gap_labour_hours_limit: StringResource by lazy {
      StringResource("string:auto_assign_gap_labour_hours_limit", "auto_assign_gap_labour_hours_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31818, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 44266, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26757, 74),
      ))
    }

@delegate:ResourceContentHash(1_076_586_952)
public val Res.string.auto_assign_gap_needs_non_lead: StringResource by lazy {
      StringResource("string:auto_assign_gap_needs_non_lead", "auto_assign_gap_needs_non_lead", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31901, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 44381, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26832, 74),
      ))
    }

@delegate:ResourceContentHash(-1_278_723_359)
public val Res.string.auto_assign_gap_needs_shift_lead: StringResource by lazy {
      StringResource("string:auto_assign_gap_needs_shift_lead", "auto_assign_gap_needs_shift_lead", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 31984, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 44488, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26907, 72),
      ))
    }

@delegate:ResourceContentHash(1_236_819_005)
public val Res.string.auto_assign_gap_needs_supervision: StringResource by lazy {
      StringResource("string:auto_assign_gap_needs_supervision", "auto_assign_gap_needs_supervision", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32073, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 44609, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26980, 69),
      ))
    }

@delegate:ResourceContentHash(738_536_844)
public val Res.string.auto_assign_gap_no_availability: StringResource by lazy {
      StringResource("string:auto_assign_gap_no_availability", "auto_assign_gap_no_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32147, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 44703, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27050, 67),
      ))
    }

@delegate:ResourceContentHash(-892_869_126)
public val Res.string.auto_assign_gap_no_staff: StringResource by lazy {
      StringResource("string:auto_assign_gap_no_staff", "auto_assign_gap_no_staff", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32215, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 44799, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27118, 56),
      ))
    }

@delegate:ResourceContentHash(1_881_350_606)
public val Res.string.auto_assign_gap_no_target_hours: StringResource by lazy {
      StringResource("string:auto_assign_gap_no_target_hours", "auto_assign_gap_no_target_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32276, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 44888, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27175, 71),
      ))
    }

@delegate:ResourceContentHash(-1_099_630_835)
public val Res.string.auto_assign_gap_no_weekly_rest: StringResource by lazy {
      StringResource("string:auto_assign_gap_no_weekly_rest", "auto_assign_gap_no_weekly_rest", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32344, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 44980, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27247, 90),
      ))
    }

@delegate:ResourceContentHash(-320_806_583)
public val Res.string.auto_assign_gap_not_qualified: StringResource by lazy {
      StringResource("string:auto_assign_gap_not_qualified", "auto_assign_gap_not_qualified", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32439, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 45107, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27338, 81),
      ))
    }

@delegate:ResourceContentHash(88_677_979)
public val Res.string.auto_assign_gap_outside_preferred_slot: StringResource by lazy {
      StringResource("string:auto_assign_gap_outside_preferred_slot", "auto_assign_gap_outside_preferred_slot", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32541, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 45237, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27420, 90),
      ))
    }

@delegate:ResourceContentHash(624_132_974)
public val Res.string.auto_assign_gap_overlaps_own_shift: StringResource by lazy {
      StringResource("string:auto_assign_gap_overlaps_own_shift", "auto_assign_gap_overlaps_own_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32616, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 45352, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27511, 78),
      ))
    }

@delegate:ResourceContentHash(-1_235_327_393)
public val Res.string.auto_assign_gap_person: StringResource by lazy {
      StringResource("string:auto_assign_gap_person", "auto_assign_gap_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32767, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 45563, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27654, 46),
      ))
    }

@delegate:ResourceContentHash(-1_866_899_373)
public val Res.string.auto_assign_gap_personal_constraint: StringResource by lazy {
      StringResource("string:auto_assign_gap_personal_constraint", "auto_assign_gap_personal_constraint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32699, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 45475, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27590, 63),
      ))
    }

@delegate:ResourceContentHash(1_058_659_475)
public val Res.string.auto_assign_gap_staff_check_expired: StringResource by lazy {
      StringResource("string:auto_assign_gap_staff_check_expired", "auto_assign_gap_staff_check_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32814, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 45610, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27701, 91),
      ))
    }

@delegate:ResourceContentHash(1_220_629_664)
public val Res.string.auto_assign_gap_target_reached: StringResource by lazy {
      StringResource("string:auto_assign_gap_target_reached", "auto_assign_gap_target_reached", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32918, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 45766, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27793, 70),
      ))
    }

@delegate:ResourceContentHash(10_786_431)
public val Res.string.auto_assign_gap_too_many_consecutive_days: StringResource by lazy {
      StringResource("string:auto_assign_gap_too_many_consecutive_days", "auto_assign_gap_too_many_consecutive_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 32997, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 45881, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27864, 81),
      ))
    }

@delegate:ResourceContentHash(-591_819_272)
public val Res.string.auto_assign_gap_unavailable: StringResource by lazy {
      StringResource("string:auto_assign_gap_unavailable", "auto_assign_gap_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 33075, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 45987, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27946, 63),
      ))
    }

@delegate:ResourceContentHash(-690_332_054)
public val Res.string.auto_assign_intro: StringResource by lazy {
      StringResource("string:auto_assign_intro", "auto_assign_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 33143, 421),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 46075, 693),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28010, 377),
      ))
    }

@delegate:ResourceContentHash(1_219_064_147)
public val Res.string.auto_assign_nothing_to_fill: StringResource by lazy {
      StringResource("string:auto_assign_nothing_to_fill", "auto_assign_nothing_to_fill", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 33565, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 46769, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28388, 95),
      ))
    }

@delegate:ResourceContentHash(-529_136_169)
public val Res.string.auto_assign_people: StringResource by lazy {
      StringResource("string:auto_assign_people", "auto_assign_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 33673, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 46893, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28484, 50),
      ))
    }

@delegate:ResourceContentHash(-855_684_630)
public val Res.string.auto_assign_person_hours: StringResource by lazy {
      StringResource("string:auto_assign_person_hours", "auto_assign_person_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 33796, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 47040, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28607, 52),
      ))
    }

@delegate:ResourceContentHash(-1_206_772_796)
public val Res.string.auto_assign_person_hours_target: StringResource by lazy {
      StringResource("string:auto_assign_person_hours_target", "auto_assign_person_hours_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 33724, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 46960, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28535, 71),
      ))
    }

@delegate:ResourceContentHash(-180_982_829)
public val Res.string.auto_assign_planning: StringResource by lazy {
      StringResource("string:auto_assign_planning", "auto_assign_planning", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 33849, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 47101, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28660, 88),
      ))
    }

@delegate:ResourceContentHash(1_071_375_000)
public val Res.string.auto_assign_proposed: StringResource by lazy {
      StringResource("string:auto_assign_proposed", "auto_assign_proposed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 33938, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 47234, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28749, 48),
      ))
    }

@delegate:ResourceContentHash(1_396_948_653)
public val Res.string.auto_assign_select_all: StringResource by lazy {
      StringResource("string:auto_assign_select_all", "auto_assign_select_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 33991, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 47299, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28798, 46),
      ))
    }

@delegate:ResourceContentHash(-1_126_973_703)
public val Res.string.auto_assign_select_none: StringResource by lazy {
      StringResource("string:auto_assign_select_none", "auto_assign_select_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 34046, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 47358, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28845, 39),
      ))
    }

@delegate:ResourceContentHash(2_103_056_902)
public val Res.string.auto_assign_skipped: StringResource by lazy {
      StringResource("string:auto_assign_skipped", "auto_assign_skipped", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 34090, 139),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 47414, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28885, 123),
      ))
    }

@delegate:ResourceContentHash(1_715_675_764)
public val Res.string.auto_assign_targets_not_used: StringResource by lazy {
      StringResource("string:auto_assign_targets_not_used", "auto_assign_targets_not_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 34230, 184),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 47590, 296),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29009, 180),
      ))
    }

@delegate:ResourceContentHash(-206_605_264)
public val Res.string.auto_assign_title: StringResource by lazy {
      StringResource("string:auto_assign_title", "auto_assign_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 34415, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 47887, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29190, 57),
      ))
    }

@delegate:ResourceContentHash(-1_412_973_355)
public val Res.string.auto_assign_unfilled: StringResource by lazy {
      StringResource("string:auto_assign_unfilled", "auto_assign_unfilled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 34493, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 48001, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29248, 56),
      ))
    }

@delegate:ResourceContentHash(-1_325_397_550)
public val Res.string.auto_assign_warn_days_without_lead: StringResource by lazy {
      StringResource("string:auto_assign_warn_days_without_lead", "auto_assign_warn_days_without_lead", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 34562, 226),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 48102, 358),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29305, 194),
      ))
    }

@delegate:ResourceContentHash(1_369_693_104)
public val Res.string.auto_assign_warn_first_roster: StringResource by lazy {
      StringResource("string:auto_assign_warn_first_roster", "auto_assign_warn_first_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 34789, 233),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 48461, 317),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29500, 193),
      ))
    }

@delegate:ResourceContentHash(2_044_839_835)
public val Res.string.auto_assign_warn_kept_breaks_rule: StringResource by lazy {
      StringResource("string:auto_assign_warn_kept_breaks_rule", "auto_assign_warn_kept_breaks_rule", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 35023, 149),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 48779, 217),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29694, 145),
      ))
    }

@delegate:ResourceContentHash(875_285_177)
public val Res.string.auto_assign_warn_no_availability: StringResource by lazy {
      StringResource("string:auto_assign_warn_no_availability", "auto_assign_warn_no_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 35173, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 48997, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29840, 76),
      ))
    }

@delegate:ResourceContentHash(2_030_840_346)
public val Res.string.auto_assign_warn_no_leads: StringResource by lazy {
      StringResource("string:auto_assign_warn_no_leads", "auto_assign_warn_no_leads", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 35254, 397),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 49102, 577),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29917, 313),
      ))
    }

@delegate:ResourceContentHash(1_193_053_085)
public val Res.string.auto_assign_warn_other_workplaces: StringResource by lazy {
      StringResource("string:auto_assign_warn_other_workplaces", "auto_assign_warn_other_workplaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 35652, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 49680, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30231, 113),
      ))
    }

@delegate:ResourceContentHash(2_095_544_805)
public val Res.string.auto_assign_warn_pay_terms: StringResource by lazy {
      StringResource("string:auto_assign_warn_pay_terms", "auto_assign_warn_pay_terms", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 35750, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 49806, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30345, 94),
      ))
    }

@delegate:ResourceContentHash(503_083_513)
public val Res.string.auto_assign_warn_range: StringResource by lazy {
      StringResource("string:auto_assign_warn_range", "auto_assign_warn_range", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 35849, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 49949, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30440, 78),
      ))
    }

@delegate:ResourceContentHash(859_078_336)
public val Res.string.auto_assign_why_after_long_break: StringResource by lazy {
      StringResource("string:auto_assign_why_after_long_break", "auto_assign_why_after_long_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 35932, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50064, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30519, 64),
      ))
    }

@delegate:ResourceContentHash(1_178_399_436)
public val Res.string.auto_assign_why_balanced_hours: StringResource by lazy {
      StringResource("string:auto_assign_why_balanced_hours", "auto_assign_why_balanced_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36005, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50157, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30584, 58),
      ))
    }

@delegate:ResourceContentHash(-794_657_635)
public val Res.string.auto_assign_why_below_target: StringResource by lazy {
      StringResource("string:auto_assign_why_below_target", "auto_assign_why_below_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36068, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50236, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30643, 76),
      ))
    }

@delegate:ResourceContentHash(1_541_044_699)
public val Res.string.auto_assign_why_best_fit: StringResource by lazy {
      StringResource("string:auto_assign_why_best_fit", "auto_assign_why_best_fit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36137, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50345, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30720, 44),
      ))
    }

@delegate:ResourceContentHash(-767_264_225)
public val Res.string.auto_assign_why_extends_run: StringResource by lazy {
      StringResource("string:auto_assign_why_extends_run", "auto_assign_why_extends_run", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36198, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50426, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30765, 75),
      ))
    }

@delegate:ResourceContentHash(-60_991_085)
public val Res.string.auto_assign_why_non_lead_needed: StringResource by lazy {
      StringResource("string:auto_assign_why_non_lead_needed", "auto_assign_why_non_lead_needed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36270, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50534, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30841, 79),
      ))
    }

@delegate:ResourceContentHash(-2_046_571_404)
public val Res.string.auto_assign_why_owner_morning: StringResource by lazy {
      StringResource("string:auto_assign_why_owner_morning", "auto_assign_why_owner_morning", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36350, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50638, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30921, 65),
      ))
    }

@delegate:ResourceContentHash(1_691_552_521)
public val Res.string.auto_assign_why_preferred_slot: StringResource by lazy {
      StringResource("string:auto_assign_why_preferred_slot", "auto_assign_why_preferred_slot", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36416, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50712, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30987, 66),
      ))
    }

@delegate:ResourceContentHash(-1_442_781_140)
public val Res.string.auto_assign_why_scarce_availability: StringResource by lazy {
      StringResource("string:auto_assign_why_scarce_availability", "auto_assign_why_scarce_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36479, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50799, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31054, 67),
      ))
    }

@delegate:ResourceContentHash(956_697_104)
public val Res.string.auto_assign_why_shift_lead_needed: StringResource by lazy {
      StringResource("string:auto_assign_why_shift_lead_needed", "auto_assign_why_shift_lead_needed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36555, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 50899, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31122, 73),
      ))
    }

@delegate:ResourceContentHash(223_233_940)
public val Res.string.availability_active_requests: StringResource by lazy {
      StringResource("string:availability_active_requests", "availability_active_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36685, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 51077, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31232, 56),
      ))
    }

@delegate:ResourceContentHash(-1_142_559_486)
public val Res.string.availability_add_note_placeholder: StringResource by lazy {
      StringResource("string:availability_add_note_placeholder", "availability_add_note_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36742, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 51150, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31289, 57),
      ))
    }

@delegate:ResourceContentHash(-1_436_108_699)
public val Res.string.availability_all_available: StringResource by lazy {
      StringResource("string:availability_all_available", "availability_all_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36808, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 51232, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31347, 62),
      ))
    }

@delegate:ResourceContentHash(-1_685_186_522)
public val Res.string.availability_all_set_available: StringResource by lazy {
      StringResource("string:availability_all_set_available", "availability_all_set_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36875, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 51311, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31410, 78),
      ))
    }

@delegate:ResourceContentHash(368_322_453)
public val Res.string.availability_any_month_hint: StringResource by lazy {
      StringResource("string:availability_any_month_hint", "availability_any_month_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 36966, 151),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 51426, 231),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31489, 135),
      ))
    }

@delegate:ResourceContentHash(-1_991_458_194)
public val Res.string.availability_any_month_title: StringResource by lazy {
      StringResource("string:availability_any_month_title", "availability_any_month_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37118, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 51658, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31625, 72),
      ))
    }

@delegate:ResourceContentHash(158_382_882)
public val Res.string.availability_apply_week_template: StringResource by lazy {
      StringResource("string:availability_apply_week_template", "availability_apply_week_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37203, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 51775, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31698, 68),
      ))
    }

@delegate:ResourceContentHash(-18_596_971)
public val Res.string.availability_auto_saving: StringResource by lazy {
      StringResource("string:availability_auto_saving", "availability_auto_saving", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37276, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 51880, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31767, 52),
      ))
    }

@delegate:ResourceContentHash(-581_356_827)
public val Res.string.availability_available: StringResource by lazy {
      StringResource("string:availability_available", "availability_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37345, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 51957, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31820, 42),
      ))
    }

@delegate:ResourceContentHash(-2_062_507_758)
public val Res.string.availability_comment_only_here: StringResource by lazy {
      StringResource("string:availability_comment_only_here", "availability_comment_only_here", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37388, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52012, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31863, 94),
      ))
    }

@delegate:ResourceContentHash(965_395_799)
public val Res.string.availability_copied_previous: StringResource by lazy {
      StringResource("string:availability_copied_previous", "availability_copied_previous", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37483, 112),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52159, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31958, 96),
      ))
    }

@delegate:ResourceContentHash(-2_004_764_199)
public val Res.string.availability_copy_previous: StringResource by lazy {
      StringResource("string:availability_copy_previous", "availability_copy_previous", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37596, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52320, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32055, 54),
      ))
    }

@delegate:ResourceContentHash(140_660_926)
public val Res.string.availability_create_new_template: StringResource by lazy {
      StringResource("string:availability_create_new_template", "availability_create_new_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37667, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52415, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32110, 68),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("auth_reset_password_desc", Res.string.auth_reset_password_desc)
  map.put("auth_reset_password_title", Res.string.auth_reset_password_title)
  map.put("auth_reset_sent", Res.string.auth_reset_sent)
  map.put("auth_return_to_login", Res.string.auth_return_to_login)
  map.put("auth_sign_in", Res.string.auth_sign_in)
  map.put("auth_sign_in_with_apple", Res.string.auth_sign_in_with_apple)
  map.put("auth_sign_up", Res.string.auth_sign_up)
  map.put("auth_switch_to_login", Res.string.auth_switch_to_login)
  map.put("auth_switch_to_register", Res.string.auth_switch_to_register)
  map.put("auth_toggle_password_visibility", Res.string.auth_toggle_password_visibility)
  map.put("auth_verification_sent", Res.string.auth_verification_sent)
  map.put("auth_verify_email", Res.string.auth_verify_email)
  map.put("auth_verify_email_desc", Res.string.auth_verify_email_desc)
  map.put("auth_verify_email_title", Res.string.auth_verify_email_title)
  map.put("auto_assign", Res.string.auto_assign)
  map.put("auto_assign_ai_badge", Res.string.auto_assign_ai_badge)
  map.put("auto_assign_ai_dropped", Res.string.auto_assign_ai_dropped)
  map.put("auto_assign_ai_dropped_because", Res.string.auto_assign_ai_dropped_because)
  map.put("auto_assign_ai_dropped_duplicate", Res.string.auto_assign_ai_dropped_duplicate)
  map.put("auto_assign_ai_dropped_shift", Res.string.auto_assign_ai_dropped_shift)
  map.put("auto_assign_ai_dropped_shift_not_open", Res.string.auto_assign_ai_dropped_shift_not_open)
  map.put("auto_assign_ai_dropped_unknown_alias", Res.string.auto_assign_ai_dropped_unknown_alias)
  map.put("auto_assign_ai_dropped_unknown_person", Res.string.auto_assign_ai_dropped_unknown_person)
  map.put("auto_assign_ai_fallback_disabled", Res.string.auto_assign_ai_fallback_disabled)
  map.put("auto_assign_ai_fallback_failed", Res.string.auto_assign_ai_fallback_failed)
  map.put("auto_assign_ai_fallback_not_allowed", Res.string.auto_assign_ai_fallback_not_allowed)
  map.put("auto_assign_ai_fallback_plan", Res.string.auto_assign_ai_fallback_plan)
  map.put("auto_assign_ai_fallback_quota", Res.string.auto_assign_ai_fallback_quota)
  map.put("auto_assign_ai_fallback_too_large", Res.string.auto_assign_ai_fallback_too_large)
  map.put("auto_assign_ai_planning", Res.string.auto_assign_ai_planning)
  map.put("auto_assign_ai_privacy", Res.string.auto_assign_ai_privacy)
  map.put("auto_assign_ai_suggest", Res.string.auto_assign_ai_suggest)
  map.put("auto_assign_ai_used", Res.string.auto_assign_ai_used)
  map.put("auto_assign_applied", Res.string.auto_assign_applied)
  map.put("auto_assign_apply", Res.string.auto_assign_apply)
  map.put("auto_assign_gap_absent", Res.string.auto_assign_gap_absent)
  map.put("auto_assign_gap_already_working_that_day", Res.string.auto_assign_gap_already_working_that_day)
  map.put("auto_assign_gap_busy_elsewhere", Res.string.auto_assign_gap_busy_elsewhere)
  map.put("auto_assign_gap_insufficient_rest", Res.string.auto_assign_gap_insufficient_rest)
  map.put("auto_assign_gap_labour_hours_limit", Res.string.auto_assign_gap_labour_hours_limit)
  map.put("auto_assign_gap_needs_non_lead", Res.string.auto_assign_gap_needs_non_lead)
  map.put("auto_assign_gap_needs_shift_lead", Res.string.auto_assign_gap_needs_shift_lead)
  map.put("auto_assign_gap_needs_supervision", Res.string.auto_assign_gap_needs_supervision)
  map.put("auto_assign_gap_no_availability", Res.string.auto_assign_gap_no_availability)
  map.put("auto_assign_gap_no_staff", Res.string.auto_assign_gap_no_staff)
  map.put("auto_assign_gap_no_target_hours", Res.string.auto_assign_gap_no_target_hours)
  map.put("auto_assign_gap_no_weekly_rest", Res.string.auto_assign_gap_no_weekly_rest)
  map.put("auto_assign_gap_not_qualified", Res.string.auto_assign_gap_not_qualified)
  map.put("auto_assign_gap_outside_preferred_slot", Res.string.auto_assign_gap_outside_preferred_slot)
  map.put("auto_assign_gap_overlaps_own_shift", Res.string.auto_assign_gap_overlaps_own_shift)
  map.put("auto_assign_gap_person", Res.string.auto_assign_gap_person)
  map.put("auto_assign_gap_personal_constraint", Res.string.auto_assign_gap_personal_constraint)
  map.put("auto_assign_gap_staff_check_expired", Res.string.auto_assign_gap_staff_check_expired)
  map.put("auto_assign_gap_target_reached", Res.string.auto_assign_gap_target_reached)
  map.put("auto_assign_gap_too_many_consecutive_days", Res.string.auto_assign_gap_too_many_consecutive_days)
  map.put("auto_assign_gap_unavailable", Res.string.auto_assign_gap_unavailable)
  map.put("auto_assign_intro", Res.string.auto_assign_intro)
  map.put("auto_assign_nothing_to_fill", Res.string.auto_assign_nothing_to_fill)
  map.put("auto_assign_people", Res.string.auto_assign_people)
  map.put("auto_assign_person_hours", Res.string.auto_assign_person_hours)
  map.put("auto_assign_person_hours_target", Res.string.auto_assign_person_hours_target)
  map.put("auto_assign_planning", Res.string.auto_assign_planning)
  map.put("auto_assign_proposed", Res.string.auto_assign_proposed)
  map.put("auto_assign_select_all", Res.string.auto_assign_select_all)
  map.put("auto_assign_select_none", Res.string.auto_assign_select_none)
  map.put("auto_assign_skipped", Res.string.auto_assign_skipped)
  map.put("auto_assign_targets_not_used", Res.string.auto_assign_targets_not_used)
  map.put("auto_assign_title", Res.string.auto_assign_title)
  map.put("auto_assign_unfilled", Res.string.auto_assign_unfilled)
  map.put("auto_assign_warn_days_without_lead", Res.string.auto_assign_warn_days_without_lead)
  map.put("auto_assign_warn_first_roster", Res.string.auto_assign_warn_first_roster)
  map.put("auto_assign_warn_kept_breaks_rule", Res.string.auto_assign_warn_kept_breaks_rule)
  map.put("auto_assign_warn_no_availability", Res.string.auto_assign_warn_no_availability)
  map.put("auto_assign_warn_no_leads", Res.string.auto_assign_warn_no_leads)
  map.put("auto_assign_warn_other_workplaces", Res.string.auto_assign_warn_other_workplaces)
  map.put("auto_assign_warn_pay_terms", Res.string.auto_assign_warn_pay_terms)
  map.put("auto_assign_warn_range", Res.string.auto_assign_warn_range)
  map.put("auto_assign_why_after_long_break", Res.string.auto_assign_why_after_long_break)
  map.put("auto_assign_why_balanced_hours", Res.string.auto_assign_why_balanced_hours)
  map.put("auto_assign_why_below_target", Res.string.auto_assign_why_below_target)
  map.put("auto_assign_why_best_fit", Res.string.auto_assign_why_best_fit)
  map.put("auto_assign_why_extends_run", Res.string.auto_assign_why_extends_run)
  map.put("auto_assign_why_non_lead_needed", Res.string.auto_assign_why_non_lead_needed)
  map.put("auto_assign_why_owner_morning", Res.string.auto_assign_why_owner_morning)
  map.put("auto_assign_why_preferred_slot", Res.string.auto_assign_why_preferred_slot)
  map.put("auto_assign_why_scarce_availability", Res.string.auto_assign_why_scarce_availability)
  map.put("auto_assign_why_shift_lead_needed", Res.string.auto_assign_why_shift_lead_needed)
  map.put("availability_active_requests", Res.string.availability_active_requests)
  map.put("availability_add_note_placeholder", Res.string.availability_add_note_placeholder)
  map.put("availability_all_available", Res.string.availability_all_available)
  map.put("availability_all_set_available", Res.string.availability_all_set_available)
  map.put("availability_any_month_hint", Res.string.availability_any_month_hint)
  map.put("availability_any_month_title", Res.string.availability_any_month_title)
  map.put("availability_apply_week_template", Res.string.availability_apply_week_template)
  map.put("availability_auto_saving", Res.string.availability_auto_saving)
  map.put("availability_available", Res.string.availability_available)
  map.put("availability_comment_only_here", Res.string.availability_comment_only_here)
  map.put("availability_copied_previous", Res.string.availability_copied_previous)
  map.put("availability_copy_previous", Res.string.availability_copy_previous)
  map.put("availability_create_new_template", Res.string.availability_create_new_template)
}
